import { logger } from '../../utils/logger';
import { getTrackingDispatchers, TrackingEvent } from '@owc/connection-aem-tracking';

const removeEmTags = (str: string) => (str ? str.replace(/<em>/g, '').replace(/<\/em>/g, '') : '');

export default interface IApplication {
  id: string;
  version: string;
}

export class TrackingService {
  private isAemEnvironment = false;
  private eventAction = 'fss_search_header'; //fss_search_inpage
  private application: IApplication = {
    id: '',
    version: '',
  };

  getIsAemEnvironment(): boolean {
    return this.isAemEnvironment;
  }

  setAemEnviroment(): void {
    this.isAemEnvironment = true;
  }

  setApplication(application: IApplication, action: string): void {
    this.application = application;
    this.eventAction = action;
  }

  searchResultClicked({
    url,
    domain,
    index,
    query,
    autocomplete = '',
  }: {
    url: string;
    domain: string;
    index: number;
    query: string;
    autocomplete: string;
  }): TrackingEvent {
    logger.log('PushEvent searchResultClicked');
    const data = {
      event: 'click',
      eventDetail: {
        category: 'search',
        action: this.eventAction,
        label: 'search_result_selected',
        URL: removeEmTags(url),
        index,
        search: { domain, autocomplete, term: query },
      },
      application: {
        ...this.application,
        parentApplicationId: this.isAemEnvironment ? 'aem' : 'emh',
      },
    };

    this.pushEvent(data);

    return data;
  }

  searchExecuted({
    term,
    numResults = '',
    typedQuery = '',
  }: {
    term: string;
    numResults: string;
    typedQuery: string;
  }): TrackingEvent {
    logger.log('PushEvent searchExecuted');
    const search = {
      results: numResults,
      term: typedQuery ? typedQuery : term,
      autocomplete: typedQuery ? term : '',
    };
    const eventToBePushed: TrackingEvent = {
      event: 'click',
      eventDetail: {
        category: 'search',
        action: this.eventAction,
        label: 'search_executed',
        search,
      },
      application: {
        ...this.application,
        parentApplicationId: this.isAemEnvironment ? 'aem' : 'emh',
      },
    };

    this.pushEvent(eventToBePushed);

    return eventToBePushed;
  }

  private pushEvent(eventToBePushed: TrackingEvent): void {
    logger.log(`Send a click event to the tracker: ${JSON.stringify(eventToBePushed)}`);

    if (this.isAemEnvironment) {
      getTrackingDispatchers()
        .then((dispatchers) => {
          logger.log(`AEM Event pushed ${JSON.stringify(eventToBePushed)}`);
          dispatchers.pushTrackingEvent(eventToBePushed);
        })
        .catch((err) => {
          logger.log('Fail to send tracking', err);
        });
    } else {
      try {
        logger.log(`STANDALONE Event pushed`);
        window.dataLayer_ow.push(eventToBePushed);
      } catch (err) {
        logger.log(err);
      }
    }
  }
}

export const trackingService = new TrackingService();
